// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"378":"90d13b1d","907":"396572ba"}[chunkId] + ".chunk.css");